import { gql } from '@apollo/client';
import { CART_SCHEMA } from './cart.api';

const QUERIES = {
  GET_MBB_DEVICES: gql`
    query getDongles($prospectReference: String!, $cartOfferID: Int!, $catalogTariffCode: String) {
      getSelectedDongles(
        prospectReference: $prospectReference
        cartOfferID: $cartOfferID
        catalogTariffCode: $catalogTariffCode
      ) {
        prospectReference
        cartOfferID
        catalogTariffCode
        dongles {
          stockLevel
          outOfStock
          image
          imageAltText
          mobileImage
          mobileImageAltText
          title
          model
          code
          slug
          sortOrder
          manufacturer
          price
          specifications {
            value
          }
        }
      }
    }
  `,
  ADD_MBB_DONGLES: gql`
  mutation addDongle(
    $prospectUuid: String!
    $offerId: Int!
    $catalogCode: String!
    $imei: String
    $equipments: [Int]
  ) {
    addDongle(
      prospectUuid: $prospectUuid
      offerId: $offerId
      catalogCode: $catalogCode
      imei:$imei
      equipments: $equipments
    ) {
      ${CART_SCHEMA}
    }
  }
  `,
};

// to get Mbb devices
export const getMbbDevice = async ({ graphql, variables = {} }) => {
  try {
    const { data } = await graphql.query({
      query: QUERIES.GET_MBB_DEVICES,
      variables,
    });
    return data.getSelectedDongles;
  } catch (error) {
    console.error(error);
  }
};

// to add mbb dongles
export const addMbbDongles = async ({ graphql, variables = {} }) => {
  const { data } = await graphql.mutate({
    mutation: QUERIES.ADD_MBB_DONGLES,
    variables,
  });
  return data.addDongle;
};
